var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-intro"},[_c('span',{staticClass:"page-intro__eyebrow"},[_vm._v("PINKKI / "+_vm._s(_vm.label))]),_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }